import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';
import { MenuModel } from '../models/menu/menu.model';
import { MenuStylingModel } from '../models/menu/menu-styling.model';
import { ButtonMenuModel } from '../models/button-menu/button-menu.model';
import { ButtonMenuStylingModel } from '../models/button-menu/button-menu-styling.model';
import { IconModel } from '../models/icon/icon.model';
import { ButtonTemplates } from './button.template';
import { MenuTemplates } from './menu.template';

export const /** @type {?} */ ButtonMenuTemplates = {
  defaultTemplate: {
    property: new ButtonMenuModel({
      display: true,
      disable: false,
      buttonProperty: new ButtonModel( {
        label: 'Apple Products',
        iconProperty: new IconModel({
          display: true,
          name: 'fa-apple',
          size: '16px'
        }),
      }),
      menuProperty: new MenuModel( {
        menuItems: [
        {
          buttonProperty: {
            label: 'iPhone',
            iconProperty: new IconModel ({
              name: 'fa-mobile',
              size: '24px'
            }),
            iconPosition: 'left'
          },
          divider: true
        },
        {
          buttonProperty: {
            label: 'iPad',
            iconProperty: new IconModel ({
              name: 'fa-tablet',
              size: '24px'
            }),
            iconPosition: 'left'
          },
          divider: true
        },
        {
          buttonProperty: {
            label: 'Mac',
            iconProperty: new IconModel ({
              name: 'fa-laptop',
              size: '24px'
            }),
            iconPosition: 'left'
          },
          divider: true
        }
        ]
      })
    }),
    style : new ButtonStylingModel({
      container: {
        class: '',
        dynamicClass: ''
      },
      buttonStyling: new ButtonStylingModel({
        container: {
          class: 'default-container'
        },
        button: {
          themeColor: 'primary'
        }
      }),
      menuStyling: new MenuStylingModel(MenuTemplates.defaultTemplate.style)
    })
  }
}
